import CustomForm from 'components/customForm';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';

const FormComponent = ({ fileds, Position = "right", isOpen, onDrawerClose, prifix="", title, width = 40, submitForm, editableObj, loading, callback = () => {} }) => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const numericWidth = typeof width === 'number' ? width : (parseInt(width, 10) || 40);
    const computedWidth = isMobile ? '100%' : `${numericWidth}%`;
    const minWidth = isMobile ? '100%' : (numericWidth > 45 ? 'min(100vw, 650px)' : 'min(100vw, 380px)');
    const maxWidth = isMobile ? '100%' : (numericWidth > 45 ? 'min(100vw, 1200px)' : 'min(100vw, 520px)');

    return (
        <Drawer
            open={isOpen}
            onClose={onDrawerClose}
            direction={Position}
            className="masterForm"
            style={{
                width: computedWidth,
                minWidth: minWidth,
                maxWidth: maxWidth,
                boxShadow: '-4px 0 25px rgba(0,0,0,0.15)',
                background: '#ffffff'
            }}
        >
            <div className="d-flex flex-column h-100">
                <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom" style={{ background: '#f8fafc' }}>
                    <h5 className="m-0 text-dark fw-bold font-size-16 d-flex align-items-center">
                        <i className="mdi mdi-pencil-box-outline text-primary me-2 font-size-20"></i>
                        {title}
                    </h5>
                    <button
                        type="button"
                        className="btn btn-sm btn-light rounded-circle"
                        style={{ width: '32px', height: '32px', padding: 0 }}
                        onClick={onDrawerClose}
                        title="Close"
                    >
                        <i className="mdi mdi-close font-size-18 text-muted"></i>
                    </button>
                </div>
                <div className="flex-grow-1 p-4" style={{ overflowY: 'auto' }}>
                    <CustomForm
                        isOpen={isOpen}
                        callback={callback}
                        loading={loading}
                        fileds={fileds}
                        fileupload={false}
                        isType={(editableObj?.id || editableObj?.cid) ? true : false}
                        submitForm={submitForm}
                    />
                </div>
            </div>
        </Drawer>
    );
}

export default FormComponent;